import React from "react";

export const ScreenContext = React.createContext();
export const useScreenContext = () => React.useContext(ScreenContext);
